import useTranslation from "../hooks/useTranslation"
import useProfile from "../hooks/useProfile"
import useLocale from "../hooks/useLocale"
import { useSnapshot } from "valtio"
import styled from "styled-components"

const useFormatting = () => {

    const { t } = useTranslation()
    const { pState } = useProfile()
    const profile = useSnapshot(pState)
    const { lf } = useLocale()

    const formatString = (value, displayType, item, col) => {
        let result = value

        if (displayType === 'date') {
            // No date is no date — new Date(null) would print 1.1.1970.
            if (value === null || value === undefined || value === '') return ''
            const date = new Date(value)
            result = date.toLocaleDateString(profile.currentOrgLanguage)
        }

        if (displayType === 'datetime') {
            if (!value) return '—'
            const date = new Date(value)
            if (isNaN(date.getTime())) return value || ''
            const datePart = date.toLocaleDateString(profile.currentOrgLanguage)
            const h = String(date.getHours()).padStart(2, '0')
            const m = String(date.getMinutes()).padStart(2, '0')
            result = `${datePart} ${h}:${m}`
        }

        if (displayType === 'niceDate') {
            //Formats in a nice humar readable Date like : 23. januar 2024
            const date = new Date(value)
            const options = { year: 'numeric', month: 'long', day: 'numeric' };
            const formattedDate = new Intl.DateTimeFormat(profile.currentOrgLanguage, options).format(date);
            result = formattedDate
        }

        if (displayType === 'monthYear') {
            // A month, like: sep. 2026
            const options = { year: 'numeric', month: 'short' };
            result = new Intl.DateTimeFormat(profile.currentOrgLanguage, options).format(new Date(value))
        }

        if (displayType === 'amount') {
            result = lf(value, 2, 2)
        }

        if (displayType === 'percentage') {
            result = (value*100).toString().slice(0,5) + '%'
        }

        if (displayType === 'roundedAmount') {
            result = lf(Math.round(value), 0, 0)
        }

        if (displayType === 'quantity' && value === undefined) {
            result = '0'
        }

        if (displayType === 'quantity' && value !== undefined) {
            result = Number(value)
        }


        if (displayType === 'boolean') {
            if (item[col.id] === true) {
                result = t(col.values[0])
            } else {
                result = t(col.values[1])
            }
        }

        if (displayType === 'enum') {
            result = t(col.values[item[col.id]])
        }

        if (displayType === 'code') {
            result = value.toUpperCase()
        }

        if (displayType === 'code7') {
            result = value.toUpperCase().substring(0, 7)
        }

        if (displayType === 'label') {
            result = t(value)
        }

        return result

    }

    // 🧩 Updated helper function — supports array OR single object
    const formatData = (data, config) => {
        if (!data || typeof config !== 'object') return []

        const items = Array.isArray(data) ? data : [data]

        return items.map(item => {
            const formattedItem = { ...item }

            for (const [key, formatType] of Object.entries(config)) {
                if (item[key] !== undefined) {
                    formattedItem[key] = formatString(item[key], formatType, item)
                }
            }

            return formattedItem
        })
    }


    return { formatString, formatData }
}

export default useFormatting